import { createContentQuery, mapToContent } from 'app/queries/content/content'
import { createRedirectQuery, mapToRedirect } from 'app/queries/redirects'
import { GetServerSideProps } from 'next'
import { NotFoundScreen } from 'app/features/not-found/screen'

import { makeQuery } from 'app/hooks/use-query'
import { UserStore } from 'app/store/user-store'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = context.req?.userStore as UserStore

  const { slug } = context.params as { slug: string[] }

  const contentQuery = createContentQuery()
  const variables = { slug: slug[0] }

  const res = await makeQuery(contentQuery, variables, mapToContent, store)

  if (res && res.id) {
    return {
      redirect: {
        destination: `/content/${res.slug}`,
        permanent: true,
      },
    }
  }

  const redirectQuery = createRedirectQuery()
  const redirectVariables = { from: `/${slug.join('/')}` }

  const redirectRes = await makeQuery(
    redirectQuery,
    redirectVariables,
    mapToRedirect,
    store
  )

  if (redirectRes) {
    return {
      redirect: {
        destination: redirectRes,
        permanent: true,
      },
    }
  }

  return {
    notFound: true,
  }
}
export default NotFoundScreen
